import { render, staticRenderFns } from "./WorkflowAnswerValidation.vue?vue&type=template&id=28c9233d&scoped=true"
import script from "./WorkflowAnswerValidation.vue?vue&type=script&lang=js"
export * from "./WorkflowAnswerValidation.vue?vue&type=script&lang=js"
import style0 from "./WorkflowAnswerValidation.vue?vue&type=style&index=0&id=28c9233d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c9233d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VMenu})
